import { render } from "./CommonAside.vue?vue&type=template&id=40586d12&scoped=true"
import script from "./CommonAside.vue?vue&type=script&lang=js"
export * from "./CommonAside.vue?vue&type=script&lang=js"

import "./CommonAside.vue?vue&type=style&index=0&id=40586d12&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40586d12"]])

export default __exports__